import Logo from './logo/Logo';
import Nav from './nav/Nav';
import { useLoginStore } from '../../store/useLogin';
import { useFranchiseStore } from '../../store/useFranchise';
import { formatNumberWithComma } from '../../util/util';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSackDollar, faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons';

/**
 * @author taulmax
 * @date 2024.10.07
 * @description 왼쪽 섹션 컴포넌트 (로고, 네비게이션)
 */
const LeftSection = () => {
  const { name, logout } = useLoginStore();
  const { myfranchise } = useFranchiseStore();

  return (
      <aside className="!relative !h-full !bg-gradient-to-b !from-gray-900 !to-gray-800 !shadow-xl !w-64 !min-w-[16rem]">
      <div className="!flex !flex-col !h-full">
        <Logo />
        
        {/* 사용자 정보 영역 */}
        <div className="!px-4 !py-4 !border-b !border-gray-700">
          {/* 웰컴 메시지 */}
          <div className="!mb-3 !text-center">
            <div className="!bg-gray-800 !bg-opacity-30 !rounded-lg !px-4 !py-3">
              <p className="!text-xs !text-gray-400 !mb-1">환영합니다</p>
              <p className="!text-base !font-semibold !text-white !flex !items-center !justify-center !gap-2">
                {name}님 <span className="!text-lg">😊</span>
              </p>
            </div>
            {/* 로그아웃 버튼 */}
            <button
              onClick={logout}
              className="!mt-2 !text-xs !text-gray-400 hover:!text-gray-200 !transition-colors !flex !items-center !gap-1 !mx-auto"
            >
              <FontAwesomeIcon icon={faArrowRightFromBracket} className="!w-3 !h-3" />
              <span>로그아웃</span>
            </button>
          </div>
          
          {/* 복비 잔액 */}
          {myfranchise && (
            <div className="!bg-gray-800 !bg-opacity-50 !rounded-lg !p-3">
              <div className="!flex !items-center !justify-between">
                <div className="!flex !items-center !gap-2">
                  <FontAwesomeIcon icon={faSackDollar} className="!text-yellow-400 !text-sm" />
                  <span className="!text-xs !text-gray-300">복비 잔액</span>
                </div>
                <span className="!text-sm !font-bold !text-white">
                  {formatNumberWithComma(myfranchise.chargeAmount)}원
                </span>
              </div>
            </div>
          )}
        </div>
        
        <div className="!flex-1 !overflow-y-auto !overflow-x-hidden">
          <Nav />
        </div>
      </div>
    </aside>
  );
};

export default LeftSection;
